import { Dropdown } from '@design-system';
import { useSearchUsersMutation } from '@services/users/users.endpoints';
import { useEffect } from 'react';

export type UserDropdownProps = {
    onChangeAction: (userId: string) => void;
    valueKey: 'id' | 'label';
    value: string | null;
    canCreate?: boolean;
};

export const UserDropdown: React.FC<UserDropdownProps> = ({ onChangeAction, valueKey, value, canCreate }) => {
    const [searchUsers, { isLoading: isLoadingSearchUsers, data: searchUsersData }] = useSearchUsersMutation();

    useEffect(() => {
        searchUsers({});
    }, [searchUsers]);

    const options = searchUsersData?.map((user) => ({ id: user.id, label: `${user.first_name} ${user.last_name}` })) ?? [];

    // Trouver l'option correspondant à la valeur
    const selectedOption = value
        ? options.find((opt) => opt[valueKey] === value) || (canCreate && valueKey === 'label' ? { id: '', label: value } : null)
        : null;

    return (
        <Dropdown
            options={options}
            placeholder="Nom de la personne"
            disabled={isLoadingSearchUsers}
            canCreate={canCreate}
            className="mb-small-spacing"
            isSearchable
            value={selectedOption}
            onOptionChange={(option) => {
                if (option.id === '' && option.label) {
                    onChangeAction(option.label);
                } else {
                    onChangeAction(option[valueKey]);
                }
            }}
        />
    );
};
